const t = (d, r) => ((d == null ? void 0 : d._id) || (d == null ? void 0 : d.id) || d) === ((r == null ? void 0 : r._id) || (r == null ? void 0 : r.id) || r);
export {
  t as default
};
